/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { useSelector } from 'react-redux';
import ModuleNavigation from '../../components/modules/navigation/Modules.navigation';
import RichtextDialog from '../../components/widgets/form/fields/richtext/dialog/Dialog.richtext';
import UploaderWidget from '../../components/widgets/upload/Uploader';
import Loader from '../../components/Loader/Loader';
import WorkspacesMainstage from './workspaces/tabs';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './styles.css';
import { WorkspaceContentContainerStyled } from './workspaces/styles';
import store from '../../store/store';
import { setNavigationOpen } from '../../store/navigation/actions';
import Logo from 'src/components/modules/Logo/Logo';
import HeaderMenu from 'src/components/Header/Header.menu';



const ModulePage = () => {
  const themes: any = useSelector((state: any) => state.getThemes);
  const modalStates = useSelector((state: any) => state.workspaces.instances.find(instance => instance.isActive)?.modals);
  const workspaces = useSelector((state: any) => state.workspaces);
  const navigation = useSelector((state: any) => state.navigation);

  const handleLeftSidebar = () => {
    store.dispatch(setNavigationOpen(!navigation.isOpen));
  };


  return (
    <>
      <div className="main-container" style={{ backgroundColor: themes?.data?.colors?.background?.hex }}>
        <div className={`navigation-container ${navigation.isOpen ? 'opened' : 'closed'}`}>
          {navigation.isOpen &&
            <div className="flex items-center justify-between py-2 h-12 gap-2 pr-2">
              <div className="flex-shrink-0 -ml-4">    
                <Logo />
              </div>
              <div className="flex items-center gap-3 mt-2">
                <div className="rounded-full cursor-pointer mt-1" onClick={handleLeftSidebar}>
                  <span className={`e-icons ${ navigation.isOpen ? 'e-chevron-left-double' : 'e-chevron-right-double' } text-gray-400 text-xs hover:text-gray-50`}/>
                </div>
                <HeaderMenu />
              </div>
            </div>
          }
          {workspaces.instances.find(instance => instance.isActive)?.isPending ? <Loader /> : null}
          {workspaces.instances.map((workspace, index) => (
            <WorkspaceContentContainerStyled
              key={index}
              active={+workspace.isActive}
            >
              <ModuleNavigation workspace={workspace} isMenuOpen={navigation.isOpen} handleLeftSidebar={handleLeftSidebar.bind(this)} />
            </WorkspaceContentContainerStyled>
          ))}
        </div>
        <div className={`module-container ${navigation.isOpen ? 'navigation-container opened' : 'navigation-container closed'}`} style={{ height: '100%' }}>
          <div className="ui one column grid" style={{ height: '100vh', marginTop: '0rem' }}>
            <div className="column" style={{ padding: '0px', margin: '0px', height: '100%' }}>
              <WorkspacesMainstage />
            </div>
          </div>


        </div>
        <ToastContainer />
        {modalStates?.imageDialog?.isOpen ? <RichtextDialog /> : null}
        {modalStates?.multiUpload?.isOpen ? <UploaderWidget /> : null}
      </div>
    </>
  );
};

export default ModulePage;